// Generate daisyui themes with hex colors here  https://themes.ionevolve.com/ - the official site doesn't support hex codes well anymore
// TODO try oklch(14.076% 0.004 285.822) format as I could globally adjust the brightness or hhue shifts for any theme? Perhaps as second theme-set that is translated from this one but address by global?

//! don't use transparent values as threejs can't process them!
const animisticWarm = {
  //lukas colors
  'brand': "#bb1c16",
  'brand2': "#4f4f4f",
  'offwhite': "#393939",
  'heading': "#2f2f41",
  'plain': "#5C5A5A",
  //threejs objects
  'light-primary': '#ffffff',
  'light-secondary': '#ffffff',
  'table': '#6a6176',
  // 'table': '#0080ff',
  'vignette': '#190620',
  'card-bright': '#ffdf53',
  'card-brightest': '#ffffff',
  'card-dark': '#ae3814',
  'card-darkest': '#9c3314',
  'card-highlight': '#ffffff',
  'card-shadow': '#ffffff',
  'zone-1': '#e6a2bc',
  'zone-2': '#ffb4bc',
  'zone-3': '#ffc0ab',
  'zone-4': '#dda1ca',
  'zone-5': '#f7c7b1',
  'zone-text': '#15161b',
  'zone-text-contour': '#d5d5d5',
  // other standard daisyui
  'primary': '#ffffff',
  'primary-focus': '#e6e6e6',
  'primary-content': '#000000',

  'secondary': '#152747',
  'secondary-focus': '#091120',
  'secondary-content': '#ffffff',

  'accent': '#503447',
  'accent-focus': '#32202c',
  'accent-content': '#ffffff',

  'neutral': '#171618',
  'neutral-focus': '#2e2d2f',
  'neutral-content': '#dca54c',

  'base-100': '#6a6176',
  'base-200': '#2f2f41',
  'base-300': '#2e2d2f',
  'base-content': '#dca54c',

  'info': '#66c7ff',
  'success': '#87cf3a',
  'warning': '#e1d460',
  'error': '#ff6b6b',

};

const corporate = {
  //lukas colors
  'brand': "#393939",
  'brand2': "#393939",
  'offwhite': "#393939",
  'heading': "#373737",
  'plain': "#b7b69f",
  //threejs objects
  'light-primary': '#ffffff',
  'light-secondary': '#ffffff',
  // 'table': '#bdc7cb',
  'table': '#37393a',
  // 'vignette': '#7c91a1',
  'vignette': '#8ba0a0',
  'card-bright': '#c0daff',
  'card-brightest': '#ffffff',
  'card-dark': '#86cdff',
  'card-darkest': '#56479e',
  'card-highlight': '#ffffff',
  'card-shadow': '#ffffff',
  'zone-1': '#4a4b56',
  'zone-2': '#4a4b56',
  'zone-3': '#4a4b56',
  'zone-4': '#4a4b56',
  'zone-5': '#4a4b56',
  'zone-text': '#bbbbbb',
  'zone-text-contour': '#4a4b56',
  // other standard daisyui
  'primary': '#4768fa',
  'primary-focus': '#153ff9',
  'primary-content': '#161827',

  'secondary': '#7b92b2',
  'secondary-focus': '#5b769a',
  'secondary-content': '#161827',

  'accent': '#67cba0',
  'accent-focus': '#41be88',
  'accent-content': '#161827',

  'neutral': '#161827',
  'neutral-focus': '#06060a',
  'neutral-content': '#eaf0f6',

  'base-100': '#ffffff',
  'base-200': '#161827',
  'base-300': '#eaf0f6',
  'base-content': '#161827',

  'info': '#1c92f2',
  'success': '#009485',
  'warning': '#ff9900',
  'error': '#ff5724',

};

const daisyLight = {
  //lukas colors
  'brand': "#5f5f5f",
  'brand2': "#5f5f5f",
  'offwhite': "#fff6f8",
  'heading': "#2f2f41",
  'plain': "#5C5A5A",
  //threejs
  'light-primary': '#ab24ff',
  'light-secondary': '#ffffff',
  'table': '#d0b819',
  'vignette': '#ffffff',
  'card-bright': '#00b466',
  'card-brightest': '#9fd5ff',
  'card-dark': '#ffee00',
  'card-darkest': '#ffffff',
  'card-highlight': '#ffffff',
  'card-shadow': '#ffffff',
  'zone-1': '#ffffff',
  'zone-2': '#ffffff',
  'zone-3': '#ffffff',
  'zone-4': '#ffffff',
  'zone-5': '#ffffff',
  'zone-text': '#6e4832',
  'zone-text-contour': '#ffffff',
  // DaisyUI default "light" theme values. Source: https://daisyui.com/docs/themes
  'primary': '#570df8',
  'primary-focus': '#4506cb',
  'primary-content': '#ffffff',

  'secondary': '#f000b8',
  'secondary-focus': '#bd0091',
  'secondary-content': '#ffffff',

  'accent': '#37cdbe',
  'accent-focus': '#2ba69a',
  'accent-content': '#ffffff',

  'neutral': '#3b424e',
  'neutral-focus': '#2a2e37',
  'neutral-content': '#ffffff',

  'base-100': '#ffffff',
  'base-200': '#f9fafb',
  'base-300': '#ced3d9',
  'base-content': '#1e2734',

  'info': '#1c92f2',
  'success': '#009485',
  'warning': '#ff9900',
  'error': '#ff5724',
};
const blickwinkel = {
  //lukas colors
  'brand': "#e25e3e",
  'brand2': "#102f31",
  'offwhite': "#f5f2ea",
  'heading': "#102f31",
  'plain': "#5C5A5A",
  //threejs objects
  'light-primary': '#ffffff',
  'light-secondary': '#ffffff',
  'table': '#ded8c9',
  'vignette': '#102f31',
  'card-bright': '#f5f2ea',
  'card-brightest': '#ffffff',
  'card-dark': '#102f31',
  'card-darkest': '#0a1f21',
  //
  'card-highlight': '#ffffff',
  'card-shadow': '#ffffff',
  'zone-1': '#e8e4d9',
  'zone-2': '#dce2d8',
  'zone-3': '#bce3df',
  'zone-4': '#e8b39f',
  'zone-5': '#f5f2ea',
  'zone-text': '#102f31',
  'zone-text-contour': '#f5f2ea',
  // other standard daisyui
  'primary': '#102f31',
  'primary-focus': '#0a1f21',
  'primary-content': '#f5f2ea',

  'secondary': '#83c5be',
  'secondary-focus': '#5fada5',
  'secondary-content': '#102f31',

  'accent': '#e25e3e',
  'accent-focus': '#c44a2c',
  'accent-content': '#f5f2ea',

  'neutral': '#102f31',
  'neutral-focus': '#0a1f21',
  'neutral-content': '#f5f2ea',

  'base-100': '#f5f2ea',
  'base-200': '#e8e4d9',
  'base-300': '#dce2d8',
  'base-content': '#102f31',

  'info': '#66c7ff',
  'success': '#87cf3a',
  'warning': '#e1d460',
  'error': '#ff6b6b',

};

const themes = {
  animisticWarm,
  corporate,
  daisyLight,
  blickwinkel,
};
// Array of theme names for easy iteration
const themeNames = ['animisticWarm', 'corporate', 'daisyLight', 'blickwinkel'];
/** @typedef {keyof typeof animisticWarm} ThemeColorKey */
export default themes;
export { themeNames };
